import React, {memo} from 'react';
import PropTypes from 'prop-types';
import './PageTitle.less';
import {t} from '../../services/i18nHandler';

function PageTitle({title, rightComponent}) {
  return (
    <div className={`page-title-wrap ${rightComponent ? 'has-component' : ''}`}>
      <h1 className="page-title">{t(title)}</h1>
      {rightComponent}
    </div>
  );
}

PageTitle.defaultProps = {
  title: '',
};

PageTitle.propTypes = {
  title: PropTypes.string,
};

export default memo(PageTitle);
